export default "__VITE_ASSET__DlAMEJDD__ 120w, __VITE_ASSET__4NWakF_e__ 240w, __VITE_ASSET__CuwKYsPu__ 480w, __VITE_ASSET__Dms_RoDp__ 512w";